import useAxios from "../hooks/use-axios";
import { url } from "./url";

export const sitemap = async () => {
    if (!window?.location?.href?.includes("localhost") && !window?.location?.href?.includes("/404")) {
        const params = new URLSearchParams(window?.location?.search);
        if (!!params.get('from') || !!params.get('fromName') || !!params.get('to') || !!params.get('toName') || !!params.get('fromType') || !!params.get('toType') || !!params?.get('date') || !!params?.get('journey') || !!!window?.location?.search) {
            try {
                const formData = new FormData();
                formData.append("requested_path", window?.location?.href);
                formData.append("sitemap_path", "/home/app/mmrcl_front/public/sitemap.xml");
                formData.append("sitemap_build_path", "/home/app/mmrcl_front/build/sitemap.xml");
                await useAxios.post(`${url?.get_sitemap}`, formData);
            } catch (error) {
                console.error("error while adding sitemap url", error);
            }
        }
    }
};